import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectBillingAccount, selectIsPreinstall } from '@app/redux';
import { getNextBillCycleDate } from '@app/utils';

import { ADDON_KIND, ADDON_PRODUCT_KIND, VOICE_ADDONS_KINDS } from '@mfe/shared/constants';

import { ProductInstanceTypes } from '../../../../../apps/platform/src/server/dataSources/PSM/types';

export const useDisclosureListItems = (kind: string) => {
  const { t } = useTranslation('Disconnect');
  const billingAccount = useSelector(selectBillingAccount);
  const nextBillingCycleDate = getNextBillCycleDate(billingAccount);
  const hasPreinstall = useSelector(selectIsPreinstall);

  if (hasPreinstall) {
    return [t('disclosure.cif1')];
  }

  if (kind === ADDON_PRODUCT_KIND.voice || VOICE_ADDONS_KINDS.includes(kind)) {
    return [
      nextBillingCycleDate
        ? t('disclosure.voice1', { nextBillingCycleDate })
        : t('cart.disconnectDate.descriptionError'),
      t('disclosure.voice2'),
      t('disclosure.voice3'),
      t('disclosure.voice4'),
    ];
  }

  if (kind === ADDON_PRODUCT_KIND.staticIp || kind === ADDON_KIND.STATIC_IP) {
    return [
      nextBillingCycleDate
        ? t('disclosure.staticIP', { nextBillingCycleDate })
        : t('cart.disconnectDate.descriptionError'),
    ];
  }

  if (kind === ProductInstanceTypes.Internet || kind === ProductInstanceTypes.WirelessInternet) {
    return [
      nextBillingCycleDate
        ? t('disclosure.internet1', { nextBillingCycleDate })
        : t('cart.disconnectDate.descriptionError'),
      t('disclosure.internet2'),
      t('disclosure.internet3'),
    ];
  }

  return [];
};
